import {StrictMode} from "react";
import ReactDOM from "react-dom";

import ResponsiveApp from "./ResponsiveApp";

ReactDOM.render(
    <StrictMode>
        <ResponsiveApp/>
    </StrictMode>,
    document.getElementById("root")
);
